import { BarChartOut, usageNetByUser, UsageNetByUserData, UsageQuery } from "@/api";
import { appState } from "@/app/appState";
import { barTable, ChartState, LabelFor } from "../table";
import { useUsageChart } from "../useUsageChart";
import { unpricedHint, userRowLabel } from "../views";

const partLabel: LabelFor = (item) => appState.t(`usage.net.${item.key}`);

/** Predicted revenue minus LLM cost, per user. POST /usage/charts/net-by-user */
export const useNetByUserChart = (query: UsageQuery | undefined): ChartState => {
    const { data, loading, failed } = useUsageChart<UsageNetByUserData, BarChartOut>(usageNetByUser, query);
    return {
        key: "net-by-user",
        title: appState.t("usage.group.net"),
        loading,
        failed,
        hint: unpricedHint(data?.unpriced_tokens),
        table:
            data &&
            barTable(data, {
                rowLabel: appState.t("usage.user"),
                valueLabel: appState.t("usage.net.value"),
                rowLabelFor: userRowLabel,
                columnLabelFor: partLabel,
            }),
    };
};
